import { all } from "redux-saga/effects";
import { AuthWatcher } from "Sagas/AuthSaga";
import { PharmacyWatcher } from "./PharmacySaga";
import { UserWatcher } from "./UserSaga";
import { StaffWatcher } from "./StaffSaga";
import { SurgerySaga } from "./SurgerySaga";
import { GroupSaga } from "./GroupSaga";
import { PatientSaga } from "./PatientSaga";
import { ReaeatOrderSaga } from "./RepeatOrderSaga";
import { HomeSaga } from "./HomeSaga";
import { CollectionSaga } from "./CollectionSaga";
import { OrderPadSaga } from "./OrderPadSaga";
import { ActivitySaga } from "./ActivitySaga";
import { SimulatorSaga } from "./SimulatorSaga";

export default function* rootSaga() {
  yield all([
    AuthWatcher(),
    UserWatcher(),
    PharmacyWatcher(),
    StaffWatcher(),
    SurgerySaga(),
    GroupSaga(),
    PatientSaga(),
    ReaeatOrderSaga(),
    HomeSaga(),
    CollectionSaga(),
    OrderPadSaga(),
    ActivitySaga(),
    SimulatorSaga(),
  ]);
}
